import { Box } from '@mui/material';
import VibeCodeExperience from '@/features/vibeCode/VibeCodeExperience';

const VibeCodePage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '1000px',
        mx: 'auto',
        minHeight: 'calc(100vh - 56px)',
        px: { xs: 2, sm: 4 },
      }}
    >
      <VibeCodeExperience />
    </Box>
  );
};

export default VibeCodePage;
